$shm_hitalama_map_widget_float_table_filter $mol_view
	kind \text
	sub /
		<= Mode $shm_hitalama_map_widget_float_table_select
			Filter null
			value? <=> mode? \all
			dictionary <= modes *
		^ inputs /
			<= Value $mol_string
				hint <= value_hint \Значение
				value? <=> value? \
			<= Until $mol_string
				hint <= until_hint \До включительно
				value? <=> until? \
		<= Error $mol_status
			message <= error \
